module.exports = __webpack_public_path__ + "static/media/0068.345f943a.jpg";